export const ACCEPT_CONNECTION = 'ACCEPT_CONNECTION';
export const ACCEPT_CONNECTION_STARTING = 'ACCEPT_CONNECTION_STARTING';
export const ADD_TAG = 'ADD_TAG';
export const ADD_TAG_STARTING = 'ADD_TAG_STARTING';
export const CLEAR_STORES = 'CLEAR_STORES';
export const FILTER_CONNECTIONS = 'FILTER_CONNECTIONS';
export const FILTER_CONNECTIONS_BY_COUNTRY = 'FILTER_CONNECTIONS_BY_COUNTRY';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const IGNORE_CONNECTION = 'IGNORE_CONNECTION';
export const IGNORE_CONNECTION_STARTING = 'IGNORE_CONNECTION_STARTING';
export const LOAD_MORE_CONNECTIONS = 'LOAD_MORE_CONNECTIONS';
export const RESEND_CONNECTION_STARTING = 'RESEND_CONNECTION_STARTING';
export const RESEND_CONNECTION = 'RESEND_CONNECTION';
export const REMOVE_COUNTRY_FILTER = 'REMOVE_COUNTRY_FILTER';
export const REMOVE_TAG_STARTING = 'REMOVE_TAG_STARTING';
export const REMOVE_CONNECTION = 'REMOVE_CONNECTION';
export const REMOVE_TAG = 'REMOVE_TAG';
export const REMOVE_CONNECTION_STARTING = 'REMOVE_CONNECTION_STARTING';
export const SEARCH_CONTACTS_BY_COMPANY_NAME = 'SEARCH_CONTACTS_BY_COMPANY_NAME';
export const CONNECTIONS_IS_SYNCING = 'CONNECTIONS_IS_SYNCING';
export const UNDO_CONNECTION_CHANGE = 'UNDO_CONNECTION_CHANGE';
export const LOG_OUT = 'LOG_OUT';



// WEBPACK FOOTER //
// ./src/app/stores/connections/connections-constants.js